document.addEventListener('DOMContentLoaded', () => {
  setHomeReviewsHeaderHeight();
  initHomeReviewsSections();
});

window.addEventListener('load', () => {
  setHomeReviewsHeaderHeight();

  document.querySelectorAll('[data-home-reviews]').forEach((section) => {
    updateHomeReviewSlider(section);
  });
});

window.addEventListener(
  'resize',
  debounceHomeReviews(() => {
    setHomeReviewsHeaderHeight();

    document.querySelectorAll('[data-home-reviews]').forEach((section) => {
      updateHomeReviewSlider(section);
    });
  }, 100)
);

document.addEventListener('shopify:section:load', (event) => {
  setHomeReviewsHeaderHeight();

  const section = event.target.querySelector('[data-home-reviews]');

  if (section) {
    initHomeReviewsSection(section);
  }
});

function initHomeReviewsSections() {
  const sections = document.querySelectorAll('[data-home-reviews]');

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    initHomeReviewsSection(section);
  });
}

function initHomeReviewsSection(section) {
  initHomeReviewSlider(section);
  loadJudgeMeReviews(section);
}

function setHomeReviewsHeaderHeight() {
  const header = document.querySelector(
    '.custom-header.custom-header--fixed'
  );

  if (!header) {
    document.documentElement.style.setProperty(
      '--home-reviews-header-height',
      '0px'
    );

    return;
  }

  const headerHeight = header.getBoundingClientRect().height;

  document.documentElement.style.setProperty(
    '--home-reviews-header-height',
    `${headerHeight}px`
  );
}

async function loadJudgeMeReviews(section) {
  if (section.dataset.judgeMeInitialized === 'true') {
    return;
  }

  section.dataset.judgeMeInitialized = 'true';

  const publicToken = section.dataset.publicToken;
  const shopDomain = section.dataset.shopDomain;

  if (!publicToken || !shopDomain) {
    console.info(
      'Home Reviews: Judge.me public token or shop domain missing.'
    );

    return;
  }

  const averageEl = section.querySelector(
    '[data-review-average]'
  );

  const countEl = section.querySelector(
    '[data-review-count]'
  );

  const endpoint =
    `https://cache.judge.me/widgets/shopify/${encodeURIComponent(shopDomain)}` +
    `?public_token=${encodeURIComponent(publicToken)}` +
    `&featured_carousel=1` +
    `&all_reviews_rating=1` +
    `&all_reviews_count=1`;

  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(
        `Judge.me request failed: ${response.status}`
      );
    }

    const data = await response.json();

    if (
      data.all_reviews_rating !== undefined &&
      data.all_reviews_rating !== null &&
      averageEl
    ) {
      averageEl.textContent =
        formatJudgeMeRating(data.all_reviews_rating);
    }

    if (
      data.all_reviews_count !== undefined &&
      data.all_reviews_count !== null &&
      countEl
    ) {
      countEl.textContent =
        formatJudgeMeReviewCount(data.all_reviews_count);
    }
  } catch (error) {
    console.error(
      'Judge.me homepage reviews error:',
      error
    );
  }
}

function formatJudgeMeRating(value) {
  const rating = parseFloat(value);

  if (Number.isNaN(rating)) {
    return value;
  }

  return rating.toFixed(1);
}

function formatJudgeMeReviewCount(value) {
  const count = parseInt(
    String(value).replace(/,/g, ''),
    10
  );

  if (Number.isNaN(count)) {
    return value;
  }

  if (count >= 1000) {
    const formatted = count / 1000;

    if (Number.isInteger(formatted)) {
      return `${formatted}k+`;
    }

    return `${formatted.toFixed(1)}k+`;
  }

  return count.toLocaleString();
}

function isHomeReviewsMobile() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function getHomeReviewSlides(section) {
  const cards = Array.from(
    section.querySelectorAll('.home-reviews__card')
  );

  if (!isHomeReviewsMobile()) {
    return cards;
  }

  return cards.filter((card, index) => index % 2 === 0);
}

function getHomeReviewTotal(section) {
  const cards = section.querySelectorAll(
    '.home-reviews__card'
  );

  if (isHomeReviewsMobile()) {
    return Math.ceil(cards.length / 2);
  }

  return cards.length;
}

function initHomeReviewSlider(section) {
  if (
    section.dataset.reviewSliderInitialized === 'true'
  ) {
    return;
  }

  const slider = section.querySelector(
    '[data-review-grid]'
  );

  const cards = Array.from(
    section.querySelectorAll(
      '.home-reviews__card'
    )
  );

  if (!slider || cards.length === 0) {
    return;
  }

  section.dataset.reviewSliderInitialized = 'true';

  const prevButton = section.querySelector(
    '[data-review-prev]'
  );

  const nextButton = section.querySelector(
    '[data-review-next]'
  );

  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let movedDistance = 0;
  let activePointerId = null;

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      scrollHomeReviewsBySlide(
        section,
        -1
      );
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      scrollHomeReviewsBySlide(
        section,
        1
      );
    });
  }

  slider.addEventListener(
    'scroll',
    () => {
      requestAnimationFrame(() => {
        updateHomeReviewSlider(section);
      });
    },
    {
      passive: true
    }
  );

  slider.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType !== 'mouse') {
        return;
      }

      if (event.button !== 0) {
        return;
      }

      isDragging = true;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      movedDistance = 0;

      slider.classList.add('is-dragging');

      try {
        slider.setPointerCapture(
          event.pointerId
        );
      } catch (error) {
      }
    }
  );

  slider.addEventListener(
    'pointermove',
    (event) => {
      if (!isDragging) {
        return;
      }

      const deltaX =
        event.clientX - startX;

      movedDistance = Math.max(
        movedDistance,
        Math.abs(deltaX)
      );

      slider.scrollLeft =
        startScrollLeft - deltaX;
    }
  );

  slider.addEventListener(
    'pointerup',
    (event) => {
      if (!isDragging) {
        return;
      }

      finishHomeReviewDrag(
        section,
        slider,
        event,
        activePointerId
      );

      isDragging = false;
      activePointerId = null;
    }
  );

  slider.addEventListener(
    'pointercancel',
    (event) => {
      if (!isDragging) {
        return;
      }

      finishHomeReviewDrag(
        section,
        slider,
        event,
        activePointerId
      );

      isDragging = false;
      activePointerId = null;
    }
  );

  slider.addEventListener(
    'click',
    (event) => {
      if (movedDistance <= 8) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      movedDistance = 0;
    },
    true
  );

  updateHomeReviewSlider(section);
}

function finishHomeReviewDrag(
  section,
  slider,
  event,
  pointerId
) {
  slider.classList.remove(
    'is-dragging'
  );

  if (
    pointerId !== null &&
    slider.hasPointerCapture(pointerId)
  ) {
    try {
      slider.releasePointerCapture(
        pointerId
      );
    } catch (error) {
    }
  }

  snapHomeReviewSlider(section);
}

function scrollHomeReviewsBySlide(
  section,
  direction
) {
  const slider = section.querySelector(
    '[data-review-grid]'
  );

  const slides = getHomeReviewSlides(section);

  if (!slider || slides.length === 0) {
    return;
  }

  const currentIndex =
    getClosestHomeReviewIndex(
      slider,
      slides
    );

  const targetIndex = Math.max(
    0,
    Math.min(
      slides.length - 1,
      currentIndex + direction
    )
  );

  scrollToHomeReviewCard(
    slider,
    slides[targetIndex]
  );
}

function snapHomeReviewSlider(section) {
  const slider = section.querySelector(
    '[data-review-grid]'
  );

  const slides = getHomeReviewSlides(section);

  if (!slider || slides.length === 0) {
    return;
  }

  const closestIndex =
    getClosestHomeReviewIndex(
      slider,
      slides
    );

  scrollToHomeReviewCard(
    slider,
    slides[closestIndex]
  );
}

function getClosestHomeReviewIndex(
  slider,
  slides
) {
  const sliderRect =
    slider.getBoundingClientRect();

  let closestIndex = 0;
  let closestDistance = Infinity;

  slides.forEach((slide, index) => {
    const slideRect =
      slide.getBoundingClientRect();

    const distance = Math.abs(
      slideRect.left -
      sliderRect.left
    );

    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
}

function scrollToHomeReviewCard(
  slider,
  card
) {
  if (!slider || !card) {
    return;
  }

  const sliderRect =
    slider.getBoundingClientRect();

  const cardRect =
    card.getBoundingClientRect();

  const targetScrollLeft =
    slider.scrollLeft +
    cardRect.left -
    sliderRect.left;

  slider.scrollTo({
    left: targetScrollLeft,
    behavior: 'smooth'
  });
}

function updateHomeReviewSlider(section) {
  const slider = section.querySelector(
    '[data-review-grid]'
  );

  const slides = getHomeReviewSlides(section);

  if (!slider || slides.length === 0) {
    return;
  }

  const current = section.querySelector(
    '[data-review-current]'
  );

  const total = section.querySelector(
    '[data-review-total]'
  );

  const progress = section.querySelector(
    '[data-review-progress]'
  );

  const prevButton = section.querySelector(
    '[data-review-prev]'
  );

  const nextButton = section.querySelector(
    '[data-review-next]'
  );

  const activeIndex =
    getClosestHomeReviewIndex(
      slider,
      slides
    );

  const totalSlides =
    getHomeReviewTotal(section);

  if (current) {
    current.textContent = String(
      activeIndex + 1
    ).padStart(2, '0');
  }

  if (total) {
    total.textContent = String(
      totalSlides
    ).padStart(2, '0');
  }

  if (progress) {
    const maxScroll =
      slider.scrollWidth -
      slider.clientWidth;

    const initialPercentage =
      100 / totalSlides;

    let percentage =
      initialPercentage;

    if (maxScroll > 0) {
      const scrollRatio =
        slider.scrollLeft /
        maxScroll;

      percentage =
        initialPercentage +
        scrollRatio *
        (100 - initialPercentage);
    }

    percentage = Math.max(
      initialPercentage,
      Math.min(
        100,
        percentage
      )
    );

    progress.style.width =
      `${percentage}%`;
  }

  const maxScroll =
    slider.scrollWidth -
    slider.clientWidth;

  const tolerance = 3;

  if (prevButton) {
    prevButton.disabled =
      slider.scrollLeft <= tolerance;

    prevButton.style.opacity =
      prevButton.disabled
        ? '0.35'
        : '1';

    prevButton.style.cursor =
      prevButton.disabled
        ? 'default'
        : 'pointer';
  }

  if (nextButton) {
    nextButton.disabled =
      slider.scrollLeft >=
      maxScroll - tolerance;

    nextButton.style.opacity =
      nextButton.disabled
        ? '0.35'
        : '1';

    nextButton.style.cursor =
      nextButton.disabled
        ? 'default'
        : 'pointer';
  }
}

function debounceHomeReviews(
  callback,
  delay
) {
  let timeout;

  return function () {
    clearTimeout(timeout);

    timeout = setTimeout(
      callback,
      delay
    );
  };
}